module.exports = __webpack_public_path__ + "static/media/Filter.b7d66211.svg";